import { useMediaQuery, useTheme } from "@mui/material";
import { useCallback, useState } from "react";

import type { ScoutInfoPanelTab } from "./scoutInfoPanelContent";

/**
 * Manages Scout's Sources / Privacy & Data panel across breakpoints.
 *
 * - Closed by default; toggled via the Privacy & Data toolbar button.
 * - `sm` and up: panel uses a persistent right `Drawer` beside the chat when open.
 * - Below `sm` (mobile): panel opens as a temporary fullscreen `Drawer` overlay.
 */
export function useScoutInfoPanel() {
  const theme = useTheme();
  const isPersistentMode = useMediaQuery(theme.breakpoints.up("sm"));
  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState<ScoutInfoPanelTab>("sources");

  const togglePrivacyPanel = useCallback(() => {
    setOpen((current) => {
      if (current) {
        return false;
      }

      setTab("sources");
      return true;
    });
  }, []);

  const closePanel = useCallback(() => {
    setOpen(false);
  }, []);

  return {
    open,
    tab,
    setTab,
    isPersistentMode,
    togglePrivacyPanel,
    closePanel,
  };
}
